import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'EDITAMA.TECH',
    shortName: 'editama.tech',
    description: "An independent technology journal and engineering portfolio. Software engineering, AI experiments, autonomous agents and practical automation, documented in the open.",
    tagline: 'I build calm, useful software.',
    supportingTagline: 'From self-hosted tools to autonomous agents.',
    philosophy: ['Show the work.', 'Explain the thinking.', 'Share what you learn.'],
    url: 'https://editama.tech',
    ogImage: '/og/editama-tech.png',
    ogImageWidth: 1200,
    ogImageHeight: 900,
    locale: 'en_US',
    nav: [
        { label: 'Work', href: '/projects' },
        { label: 'AI Lab', href: '/lab' },
        { label: 'Journal', href: '/journal' },
        { label: 'About', href: '/about' },
        { label: 'Contact', href: '/contact' }
    ]
}
